import AppLayout from "../components/layout/AppLayout";
import ReminderTable from "../components/reminder/ReminderComponent";

export default function Reminder() {
  return (
    <AppLayout>
      <ReminderTable />
    </AppLayout>
  );
}
